/**
 * Grava o cookie `NEXT_LOCALE` ao trocar de idioma. Com `localeDetection`
 * ligado, o Next usa esse cookie antes do `Accept-Language` — sem ele, quem
 * escolhesse outro idioma voltaria ao da máquina na próxima visita à raiz.
 */
export function persistLocale(locale: string): void {
  document.cookie = `NEXT_LOCALE=${locale};path=/;max-age=31536000;samesite=lax`
}
